import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import PieceListSearchBar from "../../components/piece/pieceListWithSearchBar";
import { useDashboardContext } from "../../context/dashboardContext";
import { PieceResponseDTOMin } from "../../openapi-generated-client";

export default function DashboardLikedPiecesPage() {

    const {appContext, sessionId} = useDashboardContext();
    const {likeController} = appContext;

    const [data, setData] = useState<PieceResponseDTOMin[] | undefined>(undefined);

    async function fetchData() {
        setData((await likeController.getLikedPieces(sessionId)).data);
    }

    useEffect(( )=> {
        fetchData();
    }, []);

    if(data == undefined) return <Loader/>;

    return <PieceListSearchBar displayProps={{
            linkPrefix: "/pieces",
            hideComposer: true,
            hideIconDisplay: true,
            hideInfos: true,
            hideInstrumentation: true
        }} pieces={data || []}/>;
}